<template>
  <div class="page">
    <p class="p1">
      新用户专享
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="content-class">
      <div class="search-span">
        <span>ICCID：</span>
        <span class="span-left">{{propsParams.iccid}}</span>
      </div>
      <div class="search-span">
        <span>套餐名：</span>
        <span class="span-left">{{propsParams.productName}}</span>
      </div>
      <div class="search-span">
        <span>流量：</span>
        <span class="span-left">{{propsParams.totalFlow}}</span>
      </div>
      <div class="search-span">
        <span>有效期：</span>
        <span class="span-left">{{propsParams.validTime}}</span>
      </div>
      <div class="search-box" v-if="propsParams.showPhone == '1'">
        <span>手机号：</span>
        <input class="search-input" v-model="phone" placeholder="请输入联系电话" type="tel" maxlength="11"/>
      </div>
      <div class="search-box" v-if="propsParams.showPhone == '1'">
        <span>验证码：</span>
        <input class="search-input" v-model="code" placeholder="请输入验证码" type="tel" maxlength="4"/>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
        </div>
      </div>
      <div class="explain">
        <p class="p_tips">赠送流量说明：</p>
        <!-- <p class="p_class"><i class="p_class_i">．</i>视频监控新用户专享流量，单张卡限领一次;</p>
        <p class="p_class"><i class="p_class_i">．</i>流量自领取日生效，有效期15天，后续请充值使用;</p>
        <p class="p_class"><i class="p_class_i">．</i>此为免费赠送流量，不退换、不转移、不兑换。</p> -->
        <div class="p2">{{propsParams.description}}</div>
      </div>

    </div>
    <div class="footer">
      <nut-button @click="next">立即领取</nut-button>
    </div>
  </div>
</template>

<script>

import { wx_getReceiveProductDetail } from "@/api/api.js";   //领取套餐的详情
import { wx_sendReceiveSms } from "@/api/api.js";   //领取套餐的详情
import { wx_receiveProduct } from "@/api/api.js";   //领取套餐的详情

export default {
  data() {
    return {
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,

      propsParams:{
        showPhone:"1"
      },
      phone:"",
      code:""
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 初始化获取数据
    initializationData(){
      let params= {
        iccid:this.$route.query.iccid,
      }
      wx_getReceiveProductDetail(params).then(res=>{
        if(res.data.code == 200){
          this.propsParams = res.data.data;
          this.propsParams.validTime = this.propsParams.validTime.substr(0,10);
          
        }
      })
    },
    // 获取验证码
    getCode(){
      let params={
        phone: this.phone,
        iccid:this.$route.query.iccid
      }
      if(!this.phone){
        return this.$toast.fail("手机号不能为空");
      }
      wx_sendReceiveSms(params).then(res=>{
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
  //  领取流量
   next(){
      let params= {
        iccid:this.$route.query.iccid,
        phone:this.phone,
        verCode:this.code,
        productId:this.propsParams.productId
      }
      wx_receiveProduct(params).then(res=>{
        if(res.data.code == 200){
          this.$toast.success('领取成功！');
          setTimeout(() => {
            this.$router.push({
              name: "info",
              query: {
                iccid: this.$route.query.iccid
              }
            })
          }, 2000);
        }else{
          this.$toast.fail(res.data.message);
        }
      })
   },

  },
  created() {
    
  },
  mounted() {
    window.document.title = "新用户专享";
    this.initializationData()
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
        z-index: 2;
      }
    }
    .content-class{
      padding-bottom: 75px;
      .search-span{
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
        font-size: 14px;
        border: 1px solid #000;
        height: 40px;
        line-height: 40px;
        text-indent: 10px;
        border-radius: 5px;
      }
      .search-box{
        position: relative;
        width: 80%;
        margin: 0 auto;
        span{
          position: relative;
          left: 10px;
          top: 30px;
          color: #000;
          font-size: 14px;
        }
        input{
          width: 100%;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          text-indent: 70px;
          outline: none;
          -webkit-appearance:none;//去除input的内部阴影
          border: 1px solid #000;
          color:#000;
          font-size: 14px;
        }
      }
      .input-code {
        position: absolute;
        right: 25px;
        top: -5%;
        height: 30px;
      }
      .input-code .opt-a {
        display: block;
        width: 75px;
        height: 30px;
        line-height: 30px;
        background: #3eaef9;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }
      .explain{
        width: 80%;
        margin: 20px auto;
        p{
          margin-top: 3px;
        }
        .p_tips{
          color: #f94040;
          font-size: 14px;
        }
        .p2{
          margin-top: 5px;
          white-space: pre-wrap;
        }
      }
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
      }
    }
  }

</style>

